import { BorderColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const FormWrapper = styled.form`
	width: 400px;
	border: 1px solid ${BorderColors.Brand};
	padding: 20px;
	border-radius: ${BorderRadius.LG}px;
`;

const FieldSet = styled.div`
	margin-bottom: 10px;
	margin-top: 12px;
`;

export { FormWrapper, FieldSet };
